import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDisputeEvidenceKey,
  ShopifyDisputeFileUploadKey,
  ShopifyDisputeFileUploadToDisputeEvidenceKey,
  ShopifyDisputeFileUploadToShopKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDisputeFileUploadKey,
  "2022-07": {
    name: "Shopify Dispute File Upload",
    fields: [
      {
        name: "Id",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "id" },
        },
      },
      {
        name: "Dispute Evidence Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "disputeEvidenceType" },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "CANCELLATION_POLICY_FILE" },
            { name: "CUSTOMER_COMMUNICATION_FILE" },
            { name: "REFUND_POLICY_FILE" },
            { name: "SERVICE_DOCUMENTATION_FILE" },
            { name: "SHIPPING_DOCUMENTATION_FILE" },
            { name: "UNCATEGORIZED_FILE" },
          ],
        },
      },
      {
        name: "File Size",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "fileSize" },
        },
        configuration: {
          decimals: 0,
        },
      },
      {
        name: "File Type",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "fileType" },
        },
      },
      {
        name: "Original File Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "originalFieldName" },
        },
      },
      {
        name: "URL",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "url" },
        },
      },
      {
        name: "Dispute Evidence",
        key: ShopifyDisputeFileUploadToDisputeEvidenceKey,
        fieldType: FieldType.BelongsTo,
        configuration: {
          relatedModelKey: ShopifyDisputeEvidenceKey,
        },
      },
      {
        name: "Shop",
        key: ShopifyDisputeFileUploadToShopKey,
        fieldType: FieldType.BelongsTo,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // synced as part of ShopifyDispute
    syncConfig: { type: "inherit" },
  },
};

export const ShopifyDisputeFileUpload = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
